import { AppComposerActions } from '@/features/apps/app-actions';
import { useOpenAppRoute } from '@/features/apps/open-app-route';
import type { PluginComposerActionContext } from './native-plugin';

/** Composer contributions: the `composer` actions of the enabled Crowdex apps. */
export function PluginComposerActions({
  context,
  conversation,
}: {
  context: Pick<PluginComposerActionContext, 'disabled' | 'send'>;
  /** The conversation the composer writes to, whose workspace the actions work in. */
  conversation: { id: string; busy: boolean };
}) {
  const { disabled, send } = context;
  const openRoute = useOpenAppRoute();
  if (disabled) return null;
  return (
    <AppComposerActions
      busy={conversation.busy}
      host={{
        conversation: conversation.id,
        ask: (text) => {
          if (send === undefined) throw new Error('This composer cannot send.');
          send(text);
        },
        // From the composer, an app's route docks in this conversation (or as it asks: `in`).
        open: (action) =>
          openRoute({
            plugin: action.plugin,
            path: action.run.open,
            in: action.run.in,
            input: action.run.input,
            size: action.run.size,
            title: action.label,
            conversation: conversation.id,
          }),
      }}
    />
  );
}
